import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/shadow"
 * Contains 1 texture(s)
 */
export class CardsShadowAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/shadow';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        'shadow.png'
    ] as const;
}
